// extracted by mini-css-extract-plugin
export default {"wrapper":"Zaa","container":"aba","title":"bba","carousel":"cba","review":"eba","name":"fba","rating":"gba","heading":"hba","body":"iba"};
    if(module.hot) {
      // 1714422958257
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  